import React from 'react';
import { View, Image, StyleSheet } from 'react-native';
import { Text } from './index';
import { Theme } from '../../utils/theme';
import Ionicons from '@expo/vector-icons/Ionicons';

interface ChatAvatarProps {
  type: 'mentor' | 'user';
  userInitials?: string;
  size?: 'small' | 'medium' | 'large';
}

const ChatAvatar: React.FC<ChatAvatarProps> = ({
  type,
  userInitials,
  size = 'medium',
}) => {
  const sizeStyles = {
    small: { width: 24, height: 24 },
    medium: { width: 32, height: 32 },
    large: { width: 40, height: 40 },
  };

  const iconSizes = {
    small: 14,
    medium: 18,
    large: 22,
  };

  const fontSizes = {
    small: 10,
    medium: 12,
    large: 14,
  };

  if (type === 'mentor') {
    return (
      <View style={[styles.avatarContainer, styles.mentorAvatar, sizeStyles[size]]}>
        <Image 
          source={require('../../assets/mentor/mentor-avatar.webp')}
          style={[styles.mentorImage, sizeStyles[size]]}
          resizeMode="cover"
        />
      </View>
    );
  }

  // User avatar - show initials or default icon
  if (userInitials) {
    return (
      <View style={[styles.avatarContainer, styles.userAvatar, sizeStyles[size]]}>
        <Text 
          style={[
            styles.initialsText, 
            { fontSize: fontSizes[size] }
          ] as any}
        >
          {userInitials.toUpperCase()}
        </Text>
      </View>
    );
  }

  // Default user icon
  return (
    <View style={[styles.avatarContainer, styles.userAvatar, sizeStyles[size]]}>
      <Ionicons 
        name="person" 
        size={iconSizes[size]} 
        color={Theme.colors.surface} 
      />
    </View>
  );
};

const styles = StyleSheet.create({
  avatarContainer: {
    borderRadius: Theme.borderRadius.circle,
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
  },
  mentorAvatar: {
    backgroundColor: Theme.colors.primaryLight,
    borderWidth: 1,
    borderColor: Theme.colors.primary,
  },
  mentorImage: {
    borderRadius: Theme.borderRadius.circle,
  },
  userAvatar: {
    backgroundColor: Theme.colors.primary,
  },
  initialsText: {
    color: Theme.colors.surface,
    fontFamily: Theme.typography.fontFamily.semiBold,
  },
});

export default ChatAvatar; 